<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="font-weight-bold mt-10 title-page" tabindex="0">Habilitações e Divergências</div>
      </v-col>
    </v-row>

    <br />

    <div class="mt-4" v-if="loading">
      <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
    </div>
    <br>
    <v-divider></v-divider>
    <br>

    <div v-if="user">
      <br />
      <v-row v-if="!loading && data.length === 0">
        <v-col>
          <v-alert type="info">
            <span>Nenhuma habilitação ou divergência encontrada para os credores associados.</span>
          </v-alert>
        </v-col>
      </v-row>
      <template v-if="data.length">
        <div v-for="(item, i) in data" :key="i">
          <v-row>
            <v-col>
              <strong>Habilitação/Divergência #{{ i + 1 }}</strong>
              <br />
              <strong>Solicitado em: </strong>
              <span>{{ $moment(item.created_at).utc().format('DD/MM/YYYY') }}</span>
              <br />
              <strong class="mt-2">Nome: </strong>
              <span v-if="item.user && item.user.name">{{ item.user.name }}</span>
              <br />
              <strong class="mt-2">CPF/CNPJ: </strong>
              <span v-if="item.user && item.user.registration">{{formatRegistration(item.user.registration) }}</span>
            </v-col>

            <v-col>
              <v-row align="center" justify="end" class="mr-1">
                <v-col cols="auto">
                  <v-tooltip bottom v-if="item.reason || item.small_reason">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn 
                        v-bind="attrs" v-on="on" type="button" elevation="0"
                        tabindex="0" aria-label="Botão para visualizar as análises do status do pedido"
                        color="primary" outlined style="height: 30px;" dark @click="viewReason(item)">
                        <v-icon left>mdi-text-long </v-icon>
                        Análise
                      </v-btn>
                    </template>
                    <span>Visualizar Análise da Administração Judicial</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="auto">
                  <v-alert :color="getColorByStatus(item.status)" text-color="white"
                    shaped dense dark class="mt-4" style="max-width: 200px; height: 35px;">
                    {{ getTextByStatus(item.status) }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-expansion-panels>
                <v-expansion-panel v-for="(eventItem, eventIndex) in (item && item.items ? item.items : [])" :key="eventIndex">
                  <v-expansion-panel-header aria-label="Formulario com os dados do negócio">
                    <div>
                      <strong>Origem:</strong>
                      <span>
                        {{ truncateText(eventItem.origin || 'N/A', 30) }}
                      </span>
                      /
                      <strong>Valor:</strong>
                      <span v-if="eventItem.amount">
                        {{ formatValue(eventItem.amount, eventItem.currency) }}
                      </span>
                      <span v-else>N/A</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col>
                        <p tabindex="0">
                          <span class="section-info-title">Devedora</span>
                          <br />
                          <span class="section-info-value text-uppercase">
                            {{ eventItem.company_name }}
                          </span>
                        </p>
                        <p tabindex="0">
                          <span class="section-info-title">Origem</span>
                          <br />
                          <span class="section-info-value text-uppercase">
                            {{ eventItem.origin }}</span>
                        </p>
                        <p v-if="eventItem.request_number" tabindex="0">
                          <span class="section-info-title">Nº de Identificação</span>
                          <br />
                          <span class="section-info-value text-uppercase">{{
                            eventItem.request_number
                            }}</span>
                        </p>
                        <p tabindex="0">
                          <span class="section-info-title">Moeda</span>
                          <br />
                          <span class="section-info-value text-uppercase">
                            {{ eventItem.currency | enum(dataset.currencyTypes, 'id', 'name') }}
                          </span>
                        </p>
                        <p tabindex="0">
                          <span class="section-info-title">Valor</span>
                          <br />
                          <span class="section-info-value text-uppercase">
                            {{ formatValue(eventItem.amount, eventItem.currency) }}
                          </span>
                        </p>

                        <p tabindex="0">
                          <span class="section-info-title">Observações</span>
                          <br />
                          <span class="section-info-value text-uppercase">{{
                            eventItem.observation
                            }}</span>
                        </p>

                        <p tabindex="0">
                          <span class="section-info-title">Análise da Administração Judicial</span>
                          <br />
                          <span class="section-info-value text-uppercase" v-html="getTruncatedReason(eventItem.reason)"></span>
                          <v-btn
                            v-if="eventItem.reason && stripHtml(eventItem.reason).length > 150"
                            text
                            small
                            color="primary"
                            @click="toggleReason"
                            class="ml-2">
                            {{ isReasonExpanded ? 'Mostrar menos' : 'Mostrar mais' }}
                          </v-btn>
                        </p>

                        <p tabindex="0">
                          <span class="section-info-title">Documento(s)</span>
                          <br />
                          <span class="section-info-value">{{ item.documents ? item.documents.length : 0 }} arquivo(s)</span>
                        </p>
                        <v-row>
                          <v-col v-for="(itemDoc, docIndex) in (item.documents || [])" :key="docIndex">
                            <v-card v-if="itemDoc && itemDoc.doc_url && itemDoc.name">
                              <a :href="itemDoc.doc_url" target="_blank" rel="noopener noreferrer">
                                <v-img class="rounded-xl" lazy-src="https://picsum.photos/id/11/10/6" :height="70"
                                  :width="70" :src="itemDoc.doc_url"></v-img>
                              </a>
                              <v-card-text class="pa-0 file-text">
                                {{ itemDoc.name }}
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="item && item.items && item.items.length > 1">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </div>
      </template>

      <v-dialog v-model="dialogViewDoc" max-width="60%" @keydown.esc="cancel">
        <v-card>
          <v-img :src="selectedDoc" alt="" contain />
        </v-card>
      </v-dialog>


      <v-dialog v-model="dialogReason" max-width="600">
        <v-card>
          <v-card-title class="blue--text text--darken-2"
            style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center;">
            Análise da Administração Judicial
          </v-card-title>
          <br>
          <v-card-text v-if="selectedItemReason" tabindex="0">
            <p tabindex="0">
              <span class="section-info-title">Análise da Administração Judicial - resumida</span>
              <br />
            </p>
            <div v-html="selectedItemReason.small_reason"></div>
          </v-card-text>
          <v-card-text v-if="selectedItemReason" tabindex="0">
            <p tabindex="0">
              <span class="section-info-title">Análise da Administração Judicial - detalhada</span>
              <br />
            </p>
            <div v-html="selectedItemReason.reason"></div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" tabindex="0" text @click="dialogReason = false"
              aria-label="Botão para fechar a janela com a descrição do motivo">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>

  </v-container>
</template>
  <script>
  import 'moment/locale/pt-br'
  import { eventHub } from '@/main'
  import currencyTypes from '@/common/data/currency-types.data'
  import creditorDocTypes from '@/common/data/creditor-email-doc-types.data'
  import businessDocTypes from '@/common/data/business-doc-types.data'
  import axios from 'axios'
  
  import moment from 'moment-timezone'
  
  export default {
    data: () => ({
      user: null,
      data: [], 
      loading: false,
      dialog: false,
      dialogReason: false,
      selectedItemReason: null,
      isReasonExpanded: false,
      selectedItem: null,
      creditorDocTypes: creditorDocTypes,
      businessDocTypes: businessDocTypes,
      requestedDocDeadline: null,
      requestedDocOutOfDate: false,
      dataset: {
        contentUserAnonymous: '',
        contentUserLogged: '',
        currencyTypes: currencyTypes,
        isAssociationCreditor: false,
        userRequestedValue: 0,
        loading: false,
        clients: [],
        data: {
          items: [],
          client: null,
          release_status: null,
        }
      },
      document: {
        files: []
      },
      selectedDocument: null,
      completeReason: false,
      selectedDoc: null,
      dialogViewDoc: false,
      dialogUpdateRequestedDocs: false,
      showModal: false,
      businessDocs: [],
      mainDocs: [],
      processedDocuments: [],
      processes: [],
      isTimely: false,
      showLateWarning: false,
  
      loadingStatus: false,
      documentUploadLoading: false,
      activeDocumentId: null,
      isLoaded: false,
    }),
  
    created() {
      this.$ga.event({
        eventCategory: 'page',
        eventAction: 'action',
        eventLabel: 'click',
        eventValue: 'user-area'
      })
  
      this.loadUserInfo();
      this.loadData();
    },
  
    methods: {
      async loadData() {
        this.dataset.loading = true
        this.loadingStatus = true
  
        try {
          await this.loadText()
          // await this.loadClients();
  
          if (this.$root.user) {
            // await this.verifyAssociation()
            // await this.loadUserInfo()
            await this.load()
            await this.fetchReleaseStatus()
  
          }
        } catch (error) {
          this.$dialog.notify.error(this.$codes(error), {
            position: 'top-right',
            timeout: 2000
          })
        } finally {
          this.dataset.loading = false
        }
      },

        formatCpf(value) {
        if (!value) return '';
        return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
      },

      formatCnpj(value) {
        if (!value) return '';
        return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
      },

      formatRegistration(value) {
        if (!value) return '';
        return value.length <= 11 ? this.formatCpf(value) : this.formatCnpj(value);
      },
  
      clearSelectedFile(doc) {
        doc.selectedFile = null;
      },
  
      retryUpload(doc) {
        doc.uploadProgress = 0;
        doc.uploadStatus = "uploading";
        doc.selectedFile = null;
        this.openFileDialog(doc);
      },
  
      isLoading(doc) {
        return this.activeDocumentId === doc.id && this.documentUploadLoading;
      },
  
      openFileDialog(doc) {
  
        const mainDocs = this.mainDocs || [];
        const businessDocs = this.businessDocs || [];
        const allDocs = [
          ...mainDocs,
          ...businessDocs.flatMap((item) => item.docs || []),
        ];
  
        const pendingUpload = allDocs.find((d) => d.selectedFile && !d.uploaded);
  
        if (pendingUpload) {
          this.$dialog.notify.error(
            `Você tem o documento "${pendingUpload.name}" pendente! Por favor, envie-o antes de selecionar outro.`,
            {
              position: "top-right",
              timeout: 5000,
            }
          );
          return;
        }
  
        this.selectedDocument = doc;
        this.$refs.fileInput.click();
      },
  
      handleFileChange(event) {
        const file = event.target.files[0];
  
        if (!this.selectedDocument || typeof this.selectedDocument !== "object") {
          this.$dialog.notify.error("Documento selecionado não é válido!", {
            position: "top-right",
            timeout: 5000,
          });
          return;
        }
  
        if (file) {
          this.$set(this.selectedDocument, "selectedFile", file);
        }
      },
  
      async uploadDocument(doc, type) {
        if (!doc.selectedFile) {
          this.$dialog.notify.error("Erro ao enviar o documento selecionado!", {
            position: "top-right",
            timeout: 5000,
          });
          return;
        }
  
        const formData = new FormData();
        formData.append("file", doc.selectedFile);
        formData.append("type", type);
        formData.append("ref", doc.id);
  
        if (doc.item_id) formData.append("item_id", doc.item_id);
  
        const targetList = type === 1 ? this.mainDocs : this.businessDocs;
        const targetDoc = this.findDocumentInList(targetList, doc.id, type);
  
        if (!targetDoc) {
          this.$dialog.notify.error("Documento não encontrado!", {
            position: "top-right",
            timeout: 5000,
          });
          return;
        }
  
        try {
  
          this.activeDocumentId = doc.id
          this.documentUploadLoading = true;
  
          const response = await axios.patch(
            `/api/user-events/update-item-doc/${doc.event_id}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
  
            }
          );
  
          if (response.status === 200) {
            const docIndex = type === 1
              ? this.mainDocs.findIndex((d) => d.id === doc.id)
              : this.businessDocs.findIndex((businessDoc) =>
                  businessDoc.item_id === doc.item_id &&
                  businessDoc.docs.some((d) => d.id === doc.id)
                );
  
            if (type === 1 && docIndex !== -1) {
              this.$set(this.mainDocs, docIndex, {
                ...this.mainDocs[docIndex],
                uploadStatus: "success",
                uploaded: true,
                selectedFile: null,
              });
            } else if (type !== 1 && docIndex !== -1) {
              const businessDoc = this.businessDocs[docIndex];
              const innerDocIndex = businessDoc.docs.findIndex((d) => d.id === doc.id);
  
              if (innerDocIndex !== -1) {
                this.$set(businessDoc.docs, innerDocIndex, {
                  ...businessDoc.docs[innerDocIndex],
                  uploadStatus: "success",
                  uploaded: true,
                  selectedFile: null,
                });
              }
            }
            this.businessDocs.forEach((businessDoc) => {
              businessDoc.docs.forEach((doc) => {
                if (doc.selectedFile !== null) {
                  doc.selectedFile = null; 
                }
              });
            });
  
            this.$dialog.notify.success("Arquivo enviado com sucesso!", {
              position: "top-right",
              timeout: 5000,
            });
          } else {
            throw new Error("Erro não identificado!");
          }
        } catch (error) {
  
          const docIndex = type === 1
            ? this.mainDocs.findIndex((d) => d.id === doc.id)
            : this.businessDocs.findIndex((businessDoc) =>
              businessDoc.docs.some((d) => d.id === doc.id)
            );
  
          if (type === 1 && docIndex !== -1) {
            this.$set(this.mainDocs, docIndex, {
              ...this.mainDocs[docIndex],
              uploadStatus: "error",
              uploaded: false,
            });
          } else if (type !== 1 && docIndex !== -1) {
            const businessDoc = this.businessDocs[docIndex];
            const innerDocIndex = businessDoc.docs.findIndex((d) => d.id === doc.id);
  
            if (innerDocIndex !== -1) {
              this.$set(businessDoc.docs, innerDocIndex, {
                ...businessDoc.docs[innerDocIndex],
                uploadStatus: "error",
                uploaded: false,
              });
            }
          }
  
          this.$dialog.notify.error("Erro ao enviar o documento!", {
            position: "top-right",
            timeout: 5000,
          });
        }
  
        this.documentUploadLoading = false;
        this.activeDocumentId = null;
      },
  
      findDocumentInList(list, docId, type) {
        if (type === 1) {
          return list.find((doc) => doc.id === docId);
        } else {
          for (const businessDoc of list) {
            const foundDoc = businessDoc.docs.find((d) => d.id === docId);
            if (foundDoc) {
              return foundDoc;
            }
          }
        }
        return null;
      },
  
      getCurrencyCode(currencyType) {
        switch (currencyType) {
          case 1:
            return 'BRL';
          case 2:
            return 'USD';
          case 3:
            return 'EUR';
          default:
            return 'BRL';
        }
      },
  
      formatValue(value, currency) {
        if (value === null || value === undefined) {
          return 'N/A'
        }
  
        let options = {
          style: 'currency',
          currency: 'BRL'
        }
  
        switch (currency) {
          case 1:
            options.currency = 'BRL'
            break
          case 2:
            options.currency = 'USD'
            break
          case 3:
            options.currency = 'EUR'
            break
          default:
            options.currency = 'BRL'
        }
  
        return new Intl.NumberFormat('pt-BR', options).format(value)
      },
  
      truncateText(text, maxLength) {
        return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
      },
  
      verifyCondition() {
        return this.data.some(item => item.client && item.client.event_report_file);
      },
  
      async fetchReleaseStatus() {
        this.loadingStatus = true;

        try {
          const result = await axios.get(`/api/clients/1`);
          const data = result.data.content;

          this.dataset.data = {
            ...data, // Mantém todas as propriedades de 'content'
            release_status: data.release_status, 
          };

        } catch (error) {
          this.$dialog.notify.error(this.$codes(error), {
            position: 'top-right',
            timeout: 2000
          });
        } finally {
          this.loadingStatus = false;
        }
      },
  
      async load() {
        this.loading = true;
        this.data = [];
        this.clientDocuments = {}; // Para armazenar os detalhes dos documentos do cliente por ID

        try {
          const clientResponse = await axios.get('/api/clients/1');
          if (clientResponse.data && clientResponse.data.content && Array.isArray(clientResponse.data.content.documents)) {
            clientResponse.data.content.documents.forEach(doc => {
              this.clientDocuments[doc.id] = doc;
            });
            console.log("Detalhes dos documentos do cliente:", this.clientDocuments);
          }

          const allEventsResponse = await axios.get('/api/user-events/association-request');
          if (allEventsResponse.data.content && Array.isArray(allEventsResponse.data.content)) {
            this.data = allEventsResponse.data.content.map(event => ({
              ...event,
              creditor_name: event.user ? event.user.name : 'Nome não encontrado',
              creditor_user_id: event.user ? event.user.id : null,
              documents: this.processRequestedDocumentsForTemplate(event.requested_doc),
            }));
          }

        } catch (error) {
          this.$dialog.notify.error(this.$codes(error), {
            position: 'top-right',
            timeout: 2000
          });
        } finally {
          this.loading = false;
        }
      },
      parseRequestedDocs(requestedDocString) {
        try {
          return JSON.parse(requestedDocString);
        } catch (e) {
          console.error("Erro ao analisar requested_doc:", e);
          return [];
        }
      },
      processRequestedDocumentsForTemplate(requestedDocString) {
        let requestedDocs = [];
        const documents = [];
        try {
          if (requestedDocString) {
            requestedDocs = JSON.parse(requestedDocString);
            if (Array.isArray(requestedDocs)) {
              requestedDocs.forEach(docGroup => {
                if (docGroup && Array.isArray(docGroup.docs)) {
                  docGroup.docs.forEach(doc => {
                    if (doc && doc.id && this.clientDocuments[doc.id] && this.clientDocuments[doc.id].doc_url && this.clientDocuments[doc.id].name) {
                      documents.push(this.clientDocuments[doc.id]);
                    }
                  });
                }
              });
            }
          }
        } catch (error) {
          console.error("Erro ao processar documentos para o template:", error);
        }
        return documents;
      },
      openDoc(url) {
        this.selectedDoc = url;
        this.dialogViewDoc = true;
      },
  
      async loadText() {
        const result = await axios.get(`/api/dynamic-infos/keys`, {
          params: { keys: 'user-event-anonymous,user-event-logged' }
        })
  
        if (!result.data.content) return
  
        let contentUserAnonymous = result.data.content.find(x => x.key === 'user-event-anonymous')
        let contentUserLogged = result.data.content.find(x => x.key === 'user-event-logged')
  
        this.dataset.contentUserAnonymous = contentUserAnonymous ? contentUserAnonymous.value : ''
        this.dataset.contentUserLogged = contentUserLogged ? contentUserLogged.value : ''
      },
  
      async loadUserInfo() {
        try {
          const result = await axios.get('/api/lawyers/associated-users')
  
          this.user = result.data.content
  
        } catch (error) {
          console.error('Erro ao carregar informações do usuário:', error);
          this.$dialog.notify.error(this.$codes(error), {
            position: 'top-right',
            timeout: 2000,
          });
        }
      },
  
      
  
      getColorByStatus(status) {
        switch (status) {
          case 0:
            return 'warning'
          case 1:
            return 'accent'
          case 2:
            return 'important'
          case 3:
            return 'primary'
  
          default:
            break
        }
      },
  
      getTextByStatus(status) {
        switch (status) {
          case 0:
            return 'Aguardando análise'
          case 1:
            return 'Aprovado'
          case 2:
            return 'Rejeitado'
          case 3:
            return 'Aprovado parcial'
  
          default:
            break
        }
      },
  
  
      openDeleteDialog(item) {
        this.selectedItem = item;
        this.dialog = true;
      },

      viewReason(item) {
        this.selectedItemReason = item;
        this.dialogReason = true;
      
      },
  
      stripHtml(html) {
        if (!html) return '';
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || '';
      },
  
      getTruncatedReason(reason) {
        const rawText = this.stripHtml(reason);
        if (!this.isReasonExpanded && rawText.length > 150) {
          return rawText.substring(0, 150) + '...';
        }
        return rawText;
      },
  
      toggleReason() {
        this.isReasonExpanded = !this.isReasonExpanded;
      }
  
     
    }
  }
  </script>
  
  <style lang="scss">
  .title-page {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
  }
  
  .section-info-title {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }
  
  .section-info-value {
    font-family: 'Raleway';
    font-size: 14px;
    font-style: normal;
  }
  
  .custom-panel-header {
    min-height: 20px !important;
    line-height: 20px !important;
    padding-top: 5 !important;
    padding-bottom: 0 !important;
  }
  
  .card-title {
    border-bottom: 4px solid #2373c9 !important;
    padding-bottom: 8px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    // font-family: 'Raleway' !important;
    font-weight: 650 !important;
    font-size: 20px !important;
    font-style: bold !important;
    text-align: center !important;
  }
  
  .button-with-border {
    background-color: #ffffff;
    border: 2px solid #FF6F00;
    padding: 10px 20px;
    border-radius: 5px;
  }
  
  .button-with-border:hover {
    background-color: #f7994d;
    color: rgb(247, 243, 243) !important;
  }
  
  .compact-item {
    margin: 0;
    padding: 0;
  }
  
  .compact-item p {
    margin: 4px 0;
    font-size: 14px;
  }
  
  .doc-title {
    white-space: normal;
    word-wrap: break-word;
    max-width: calc(100% - 120px);
    margin-right: 16px;
  }
  
  .compact-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  </style>
  